<!-- An svg as reusable svelte component -->
<!-- Content: material ui invert_color -->

<script lang="ts">
	interface ComponentProps {
		height?: number;
		width?: number;
		fill?: string;
	}
	let { height = 24, width = 24, fill = 'var(--color1)' }: ComponentProps = $props();
</script>

<svg xmlns="http://www.w3.org/2000/svg" {width} {height} viewBox="0 0 24 24" {fill}>
	<g>
		<path d="M0,0h24v24H0V0z" fill="var(--color6)" />
	</g>
	<g>
		<path
			d="M12,4.81L12,19c-3.31,0-6-2.63-6-5.87c0-1.56,0.62-3.03,1.75-4.14L12,4.81 M6.35,7.56L6.35,7.56C4.9,8.99,4,10.96,4,13.13 C4,17.48,7.58,21,12,21c4.42,0,8-3.52,8-7.87c0-2.17-0.9-4.14-2.35-5.57l0,0L12,2L6.35,7.56z"
		/>
	</g>
</svg>
